// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../ui/customer/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../ui/customer/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".fn-ui-layout-column.tier-1 {\n  z-index: 28;\n}\n.fn-ui-layout-column.tier-2 {\n  z-index: 27;\n}\n.fn-ui-layout-column.tier-3 {\n  z-index: 26;\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
